import InteractiveImage from "components/InteractiveImage";
import { LoadingWrapper, Loader, UfoImg } from "./styled";
import Container from "Element/Container";
import { motion } from "framer-motion";
import React from "react";
import ufoSrc from "assets/images/ufo-wiener.png";
import { useFetchImg } from "hooks/PrefetchImg";

const LandingPage = () => {
  const { isImgLoading } = useFetchImg();
  if (isImgLoading) {
    return (
      <LoadingWrapper>
        <UfoImg src={ufoSrc} alt="" />
        <Loader>Grilling Your Wiener</Loader>
      </LoadingWrapper>
    );
  }

  return (
    <Container style={{ backgroundColor: "#585b8a" }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <InteractiveImage />
      </motion.div>
    </Container>
  );
};

export default LandingPage;
